import React from 'react';
import PropTypes from 'prop-types';
import UnifiedVideo from './UnifiedVideo';

/**
 * Backwards-compatible name for grid callers. The implementation is now the
 * same player used by feeds, galleries, lightboxes and the trip wizard.
 */
const ViewportVideo = (props) => (
  <UnifiedVideo
    {...props}
    containerClassName={`gm-viewport-video ${props.containerClassName || ''}`.trim()}
  />
);

ViewportVideo.propTypes = {
  src: PropTypes.string,
  poster: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  eager: PropTypes.bool,
  ariaLabel: PropTypes.string,
  onError: PropTypes.func,
  soundButtonClassName: PropTypes.string,
  showPlayPauseButton: PropTypes.bool,
  navigateOnClick: PropTypes.bool,
};

export default ViewportVideo;
